import PublicLayout from 'layout/PublicLayout';
import ForgotPasswordPage from 'pages/ForgotPassword';
import Login from 'pages/Login';

export const PUBLIC_ROUTES = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Login />,
  },
  {
    path: '/reset-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/verify-otp',
    element: <Login />,
  },
].map((e) => ({
  ...e,
  element: <PublicLayout>{e.element}</PublicLayout>,
}));
